export default "/assets/images/mila-feed-09-thumbnail.jpg?0e1e7d1152c5748741fc959d18bdf1a0";